import $ from 'jquery'

$(document).on(
  'click',
  '[data-behaviour~="edit-partner-segment-redirect"]',
  (e) => {
    const firmId = $('#edit_segment_as_firm').find(':selected').val()

    const data = $(e.target).data()
    const queryParams = data.redirectQueryParams

    window.location.href =
      Silverfin.Routes.companies_overview_index_path({ firm_id: firmId }) +
      '?' +
      queryParams
  }
)
